module.exports = __webpack_public_path__ + "img/formador-40.41afb334.png";